import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'; // ✅ Get pageSlug from URL

const FAQSection = () => {
    const { pageSlug } = useParams(); // ✅ Make sure you're getting it here

    const [items, setItems] = useState([]);
    const [faq, setFAQSection] = useState([]);

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/faq-items`)
            .then((res) => res.json())
            .then((info) => setItems(info));
    }, []);

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/faq`)
            .then((res) => res.json())
            .then((info) => setFAQSection(info));
    }, []);

    return (
        <section className="accordian-section">
            <div className="container">
                {faq
                    .filter(a => a.pageSlug === pageSlug)
                    .map((a, i) => (
                        <div className="row" key={i}>
                            <div className="col-12">
                                <div className="accordian_content">
                                    <h4>{a.faqText}</h4>
                                    <h2>{a.faqHeading}</h2>
                                </div>
                            </div>
                        </div>
                    ))}

                <div className="row position-relative" data-aos="fade-up">
                    <div className="col-lg-1 d-lg-block d-none" />
                    <div className="col-lg-10 col-md-12">
                        <div className="accordian-section-inner position-relative">
                            <div className="accordian-inner">
                                <div id="accordion1">
                                    {items
                                        .filter(item => item.pageSlug === pageSlug)
                                        .map((item, index) => {
                                            const headingId = `heading${index}`;
                                            const collapseId = `collapse${index}`;

                                            return (
                                                <div className="accordion-card" key={index}>
                                                    <div className="card-header" id={headingId}>
                                                        <a
                                                            href={`#${collapseId}`}
                                                            className="btn btn-link collapsed"
                                                            data-toggle="collapse"
                                                            data-target={`#${collapseId}`}
                                                            aria-expanded="false"
                                                            aria-controls={collapseId}
                                                        >
                                                            <h6>{item.accodingTitle}</h6>
                                                        </a>
                                                    </div>
                                                    <div
                                                        id={collapseId}
                                                        className="collapse"
                                                        aria-labelledby={headingId}
                                                        data-parent="#accordion1"
                                                    >
                                                        <div className="card-body">
                                                            <p className="pp text-left mb-0 p-0">{item.accodingText}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-1 d-lg-block d-none" />
                    <figure className="mb-0 faq_shape">
                        <img src="./assets/images/faq_icon.png" alt="FAQ icon" className="img-fluid" />
                    </figure>
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
